import { useEffect, useState } from "react";

import { isMobilePhone } from "../helpers/parseUserAgent";

export const useIsMobilePhone = (): boolean => {
  const [isOnMobilePhone, setIsOnMobilePhone] = useState(false);
  // The user agent is only readable in the browser, so the device is resolved after hydration.
  useEffect(() => {
    setIsOnMobilePhone(isMobilePhone());
  }, []);
  return isOnMobilePhone;
};
